import { CSS } from '../../../../theme/stitches.config';
import { SMPIcon } from '../SMPIcon';

type SMPArrowUpIconProps = {
  css?: CSS;
  style?: React.CSSProperties;
  onClick?: () => void;
};

export const SMPArrowUpIcon = (props: SMPArrowUpIconProps): JSX.Element => {
  return (
    <SMPIcon {...props} height='3' width='2'>
      <defs>
        <clipPath id='a'>
          <path data-name='Rectangle 526' fill='currentColor' d='M0 0h12.399v7.064H0z' />
        </clipPath>
      </defs>
      <g data-name='Group 674' clipPath='url(#a)'>
        <path
          data-name='Path 198'
          d='M12.4 6.076a1.3 1.3 0 0 0-.413-.652Q9.424 2.868 6.867.306a.855.855 0 0 0-.946-.252 1.012 1.012 0 0 0-.361.233Q2.918 2.918.285 5.558a.841.841 0 0 0-.224.942.826.826 0 0 0 .739.56.873.873 0 0 0 .727-.289q.606-.609 1.215-1.216L6.1 2.2a.762.762 0 0 1 .136-.127.57.57 0 0 0 .073.126q2.279 2.283 4.561 4.564a.866.866 0 0 0 .924.259.824.824 0 0 0 .565-.566l.044-.137Z'
          fill='currentColor'
        />
      </g>
    </SMPIcon>
  );
};
